import ConfiguratorTemplate from '../ConfiguratorTemplate';
import TileOrDropdownTemplate from './Component';

export default ConfiguratorTemplate(TileOrDropdownTemplate);
